export function assert(condition: any, message: string): asserts condition {
    if (!condition) {
        console.error('Assertion failed', message); // eslint-disable-line
        throw new Error(`Assertion error: ${message}`);
    }
}
